import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import filterIcon from "../../../../assest/images/filter.svg";
import FilterListIcon from "@mui/icons-material/FilterList";
const AppliedFilter = ({ data, dispatch, onSave, chipDisplay = [] }) => {
  const removeFilter = (field, value) => {
    dispatch({
      name: "removeFilterValue",
      field,
      value,
    });
    onSave();
  };

  const getDisplayValue = (value) => {
    if (typeof value === "object" && value !== null) {
      return value.label || value.value || "";
    }

    return value;
  };

  const formatFieldName = (field) => {
    return field
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  };

  const appliedFilters = chipDisplay.flatMap((field) => {
    const value = data?.[field];

    if (!Array.isArray(value) || value.length === 0) {
      return [];
    }

    return value.map((item) => ({
      field,
      fieldName: formatFieldName(field),
      value: item,
      label: getDisplayValue(item),
    }));
  });

  const hasDateFilter = data?.fromDate && data?.toDate;

  const hasFilters = appliedFilters.length > 0 || hasDateFilter;

  if (!hasFilters) {
    return (
      <Box>
        {/* <Typography variant="h6" fontWeight={600} sx={{ padding: "20px" }}>
        Apply filter to view the report
      </Typography> */}
        <Typography
          sx={{ lineHeight: "1.5", px: "5%" }}
          align="justify"
          variant="subtitle2"
        >
          Apply filters{"  "}
          <FilterListIcon
            sx={{
              position: "relative",
              top: "8px",
            }}
            color="success"
            fontSize="medium"
          />{" "}
          to narrow down the data based on your selected criteria. Easily refine
          the results to view only the relevant information, making it faster
          and simpler to analyze and manage your data.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img src={filterIcon} style={{ width: "35%", height: "30%" }} />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ marginLeft: "2%" }}>
      <Typography variant="subtitle2" fontWeight={600} mb={1}>
        Applied Filters
      </Typography>

      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {/* Date Range */}
        {hasDateFilter && (
          <Chip
            label={
              <>
                <strong>Date:</strong> {data?.fromDate || "—"} →{" "}
                {data?.toDate || "—"}
              </>
            }
            sx={{
              borderRadius: "6px",
              fontWeight: 500,
            }}
          />
        )}

        {/* Other filters */}
        {appliedFilters.map((filter, index) => (
          <Chip
            key={`${filter.field}-${index}`}
            label={
              <>
                <strong>{filter.fieldName}:</strong> {filter.label}
              </>
            }
            onDelete={() => removeFilter(filter.field, filter.value)}
            sx={{
              borderRadius: "6px",
              fontWeight: 500,
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default AppliedFilter;
